import { KitchenDepartmentType, TeamType } from 'models/team-list.model';
import { createContext, useContext } from 'react';

export type TeamListContextType = {
  addTeamFormData: TeamType[];
  setAddTeamFormData: (data: TeamType[]) => void;
  editMemberFormData: TeamType & { id?: string };
  setEditMemberFormData: (data: TeamType & { id?: string }) => void;
  departments: KitchenDepartmentType[];
};

export const TeamListContext = createContext({} as TeamListContextType);

const useTeamListContext = () => {
  const context = useContext(TeamListContext);
  return context;
};

export default useTeamListContext;
